module.exports = __webpack_public_path__ + "static/media/nar-1.97b26ee9.jpg";